export const taskStatusList = ["Terminadas", "Por terminar", "Todas"];
